import { Text } from '@dixa/lib-shared-habla';

import styles from './ResolutionModalBody.module.scss';

export function ResolutionCancelWarning(): JSX.Element {
  return (
    <Text.Paragraph subdued={true} className={styles.paragraph}>
      You will not be able to return to this modal to mark which article was
      used to resolve the issue.
    </Text.Paragraph>
  );
}
